import React from 'react';
import { ShieldOff } from 'lucide-react';
import { useAuth } from '../../context/AuthContext.js';

const normalizeList = (value) => {
    if (!value) {
        return [];
    }
    if (Array.isArray(value)) {
        return value;
    }
    return [value];
};

const PermissionGuard = ({ anyOf, allOf, fallback, children }) => {
    const { hasPermission } = useAuth();
    const anyPermissions = normalizeList(anyOf);
    const allPermissions = normalizeList(allOf);

    const passesAny = anyPermissions.length === 0 || anyPermissions.some((permission) => hasPermission(permission));
    const passesAll = allPermissions.length === 0 || allPermissions.every((permission) => hasPermission(permission));

    if (passesAny && passesAll) {
        return <>{children}</>;
    }

    if (typeof fallback !== 'undefined') {
        return typeof fallback === 'function' ? fallback() : fallback;
    }

    return (
        <div className="empty-state-text" style={{ padding: '3rem 1rem', textAlign: 'center' }}>
            <ShieldOff size={36} style={{ marginBottom: '0.75rem', color: '#b91c1c' }} />
            <h3 style={{ marginBottom: '0.5rem' }}>Acceso restringido</h3>
            <p>No tienes permisos suficientes para ver esta sección.</p>
        </div>
    );
};

export default PermissionGuard;
